import { DefaultRequest } from 'scripts/api';

Greenmile.RouteSummary = Greenmile.RouteSummary || {};

Greenmile.RouteSummary.Request = {

    getRoutesStatistics: function (criteriaChain, callback) {

        const today = Monet.Format.Date.getTodayISOString({ locale: 'en' });
        criteriaChain.criteriaChain.push({
            and: [{ eq: today, attr: "route.date" }]
        });

        const statisticsURL = 'RouteView/StatisticsByStatus';

        try {
            const request = new DefaultRequest({
                url: statisticsURL,
                method: 'post',
                data: criteriaChain,
                success: callback
            });
            request.send();
        } catch (e) {
            new Monet.Exception
                .ReturnError(this, "Error on get route information.")
                .console();
        }

    },

    getRouteInformation: function (route, callback) {
        var routeURL = 'Route/restrictions?criteria={"filters":["id","key","date","stops.id","stops.actualSize1","stops.actualSize2","stops.actualSize3","stops.plannedSize1","stops.plannedSize2","stops.plannedSize3","stops.orders.lineItems.actualSize1","stops.orders.lineItems.plannedSize1","equipmentAssignments.*","equipmentAssignments.equipment.*","equipmentAssignments.equipment.equipmentType.*"]}',
            criteriaChain = {
                criteriaChain: [
                    {
                        and: [{ eq: route.idOfObject, attr: "id" }, {
                            eq: true,
                            attr: "equipmentAssignments.principal"
                        }]
                    }]
            };

        try {
            const request = new DefaultRequest({
                url: routeURL,
                method: 'post',
                data: criteriaChain,
                success: callback
            });
            request.send();
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get route information.");
            error.console();
        }
    },

    getLineItemInformation: function (route, callback) {
        var lineItemURL = 'Route/' + route.id + '/SkuDetailWithUndeliverableSizes';

        try {
            const request = new DefaultRequest({
                url: lineItemURL,
                type: 'GET',
                success: callback
            });
            request.send();
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get route line item information.");
            error.console();
        }
    },

    getRouteExtraInformation: function (route, callback) {
        var projectionBuilder = this.createLineItemProjection(),
            lineItemURL       = 'RouteExtraLineItem/restrictions?criteria=' + projectionBuilder.projection.toString(),
            criteriaChain     = {
                criteriaChain: [
                    {
                        and: [
                            { eq: route.id, attr: "route.id" }
                        ]
                    }]
            };

        try {
            const request = new DefaultRequest({
                url: lineItemURL,
                method: 'post',
                data: criteriaChain,
                success: callback
            });
            request.send();
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get route line item information.");
            error.console();
        }
    },

    getDeliveryStatistics: function (location, callback) {
        var statisticsURL = 'Location/DeliveryStatistics?locationId=' + location.id;

        try {
            const request = new DefaultRequest({
                url: statisticsURL,
                type: 'GET',
                success: callback
            });
            request.send();
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get statistics for location.");
            error.console();
        }
    },

    getLatestServices: function (location, callback) {
        var statisticsURL = 'Location/LatestServices?locationId=' + location.id + '&firstResult=0&maxResults=5';

        try {
            const request = new DefaultRequest({
                url: statisticsURL,
                type: 'GET',
                success: callback
            });
            request.send();
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get latest services for location.");
            error.console();
        }
    },

    getChartInformation: function (location, key, callback) {

        var now, past, stringifiedParameters,
            filters = {},
            infoURL = 'Dashboard/KpiByType/' + key;

        now = new Date();
        past = new Date(now.getFullYear(), now.getMonth() - 120, 1);

        filters.startDate = past.toJSON();
        filters.endDate = now.toJSON();
        filters.topValue = 5;
        filters.locationIdList = [location.id];

        stringifiedParameters = JSON.stringify(
            filters, ["endDate", "startDate", "topValue", "locationIdList"]
        );

        try {
            const request = new DefaultRequest({
                url: infoURL,
                method: 'post',
                success: callback,
                data: stringifiedParameters
            });
            request.send();
        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "Error on get chart information for location.");
            error.console();
        }
    },

    createRouteProjection: function () {
        var projectionBuilder = new Monet.Builder.Projection();

        projectionBuilder.addField({ name: 'route.id' });
        projectionBuilder.addField({ name: 'route.key' });
        projectionBuilder.addField({ name: 'route.date' });
        projectionBuilder.addField({ name: 'route.status' });
        projectionBuilder.addField({ name: 'route.totalStops' });
        projectionBuilder.addField({ name: 'route.canceledStops' });
        projectionBuilder.addField({ name: 'route.redeliveredStops' });
        projectionBuilder.addField({ name: 'route.actualDepartures' });
        projectionBuilder.addField({ name: 'route.undeliveredStops' });
        projectionBuilder.addField({ name: 'route.organization.description' });
        projectionBuilder.addField({ name: 'route.stops.id' });
        projectionBuilder.addField({ name: 'route.stops.actualSize1' });
        projectionBuilder.addField({ name: 'route.stops.actualSize2' });
        projectionBuilder.addField({ name: 'route.stops.actualSize3' });
        projectionBuilder.addField({ name: 'route.stops.plannedSize1' });
        projectionBuilder.addField({ name: 'route.stops.plannedSize2' });
        projectionBuilder.addField({ name: 'route.stops.plannedSize3' });
        projectionBuilder.addField({ name: 'route.stops.orders.lineItems.actualSize1' });
        projectionBuilder.addField({ name: 'route.stops.orders.lineItems.plannedSize1' });
        projectionBuilder.addField({ name: 'primaryEquipment.*' });
        projectionBuilder.addField({ name: 'primaryEquipment.equipmentType.*' });

        return projectionBuilder;
    },

    createLineItemProjection: function () {
        var projectionBuilder = new Monet.Builder.Projection();

        projectionBuilder.addField({ name: '*' });
        projectionBuilder.addField({ name: 'sku.id' });
        projectionBuilder.addField({ name: 'sku.key' });
        projectionBuilder.addField({ name: 'sku.description' });

        return projectionBuilder;
    }
};